import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, Input, Label, FormGroup } from "reactstrap";
import { fetchDocumentDescriptors } from "./Axios";
import Select from "react-select";

const StepForm = ({ isOpen, onClose, onSave, step = null }) => {
  const [stepData, setStepData] = useState({
    name: "",
    description: "",
    required: false,
    kind: "",
    custom_fields: [],
    deletedCustomFields: [],
  });

  const [documentDescriptors, setDocumentDescriptors] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  useEffect(() => {
    if (isOpen) {
      fetchDocumentDescriptors().then(setDocumentDescriptors);
    }
  }, [isOpen]);

  useEffect(() => {
    setSelectedDocuments(step?.document_descriptors?.map(d => d.id) || []);
  }, [step]);

  useEffect(() => {
    setStepData({
      name: step?.name || "",
      description: step?.description || "",
      required: step?.required || false,
      kind: step?.kind || "",
      custom_fields: step?.custom_fields?.map(field => ({
        id: field.id || null,
        name: field.name || "",
        label: field.label || field.name || "",
        field_type: field.field_type || "text",
        description: field.description || "",
        tempId: field.id || `new-${Math.random()}`,
      })) || [],
      deletedCustomFields: [],
    });
  }, [step]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setStepData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
      ...(name === "kind" && value !== "document_upload" ? { document_descriptor_ids: [] } : {})
    }));

    if (name === "kind" && value !== "document_upload") {
      setSelectedDocuments([]);
    }
  };

  const handleCustomFieldChange = (tempId, field, value) => {
    setStepData(prev => ({
      ...prev,
      custom_fields: prev.custom_fields.map(cf =>
        cf.tempId === tempId ? { ...cf, [field]: value } : cf
      ),
    }));
  };

  const addCustomField = () => {
    setStepData(prev => ({
      ...prev,
      custom_fields: [
        ...prev.custom_fields,
        {
          id: null,
          name: "",
          label: "",
          field_type: "text",
          description: "",
          tempId: `new-${Math.random()}`
        }
      ],
    }));
  };

  const removeCustomField = (tempId) => {
    setStepData(prev => {
      const updatedFields = prev.custom_fields.filter(cf => cf.tempId !== tempId);
      const deletedId = prev.custom_fields.find(cf => cf.tempId === tempId)?.id;

      return {
        ...prev,
        custom_fields: updatedFields,
        deletedCustomFields: deletedId ? [...prev.deletedCustomFields, deletedId] : prev.deletedCustomFields,
      };
    });
  };

  const handleSubmit = () => {
    const formattedStepData = {
      ...stepData,
      document_descriptor_ids: stepData.kind === "document_upload" ? selectedDocuments : [],
      custom_fields_attributes: [
        ...stepData.custom_fields.map(({ id, name, label, field_type, description }) => ({
          id,
          name,
          label: name || label,
          field_type,
          description,
        })),
        ...stepData.deletedCustomFields.map(id => ({ id, _destroy: true })),
      ],
    };

    onSave(formattedStepData, step?.id);
    onClose();
  };


  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose}>{step ? "Editar Step" : "Agregar Step"}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="name">Nombre</Label>
          <Input id="name" name="name" type="text" value={stepData.name} onChange={handleChange} />
        </FormGroup>

        <FormGroup>
          <Label for="description">Descripción</Label>
          <Input id="description" name="description" type="textarea" value={stepData.description} onChange={handleChange} />
        </FormGroup>

        <FormGroup>
          <Label for="kind">Tipo de Step</Label>
          <Input id="kind" name="kind" type="select" value={stepData.kind} onChange={handleChange}>
            <option value="">Selecciona...</option>
            <option value="interview">Entrevista</option>
            <option value="document_upload">Subida de Documento</option>
            <option value="document_request">Solicitud de Documento</option>
          </Input>
        </FormGroup>

        {(stepData.kind === "document_upload" ) && (
          <FormGroup>
            <Label for="documentDescriptors">Documentos Requeridos</Label>
            <Select
              id="documentDescriptors"
              isMulti
              options={documentDescriptors.map(doc => ({
                value: doc.id,
                label: doc.name
              }))}
              value={documentDescriptors.filter(doc => selectedDocuments.includes(doc.id))
                .map(doc => ({ value: doc.id, label: doc.name }))}
              onChange={(selectedOptions) => {
                setSelectedDocuments(selectedOptions.map(option => option.value));
              }}
              placeholder="Seleccione documentos..."
            />
          </FormGroup>
        )}



        <FormGroup check>
          <Label check>
            <Input type="checkbox" name="required" checked={stepData.required} onChange={handleChange} />
            ¿Es obligatorio?
          </Label>
        </FormGroup>

        <hr />
        <Card className="bg-light border-0">
          <CardBody>
            <h5>Campos Personalizados</h5>

            {stepData.custom_fields.map((field) => (
              <Card key={field.tempId} className="mb-3">
                <CardBody>
                  <FormGroup>
                    <Label>Nombre del Campo</Label>
                    <Input
                      type="text"
                      value={field.name}
                      onChange={(e) => handleCustomFieldChange(field.tempId, "name", e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Tipo de Campo</Label>
                    <Input
                      type="select"
                      value={field.field_type}
                      onChange={(e) => handleCustomFieldChange(field.tempId, "field_type", e.target.value)}
                    >
                      <option value="text">Texto</option>
                      <option value="date">Fecha</option>
                      <option value="checkbox">Checkbox</option>
                      <option value="textarea">Área de Texto</option>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label>Descripción</Label>
                    <Input
                      type="textarea"
                      value={field.description}
                      onChange={(e) => handleCustomFieldChange(field.tempId, "description", e.target.value)}
                    />
                  </FormGroup>
                  <Button color="danger" size="sm" onClick={() => removeCustomField(field.tempId)}>Eliminar Campo</Button>
                </CardBody>
              </Card>
            ))}

            <Button color="primary" size="sm" onClick={addCustomField}>Agregar Campo Personalizado</Button>
          </CardBody>
        </Card>
            
      </ModalBody>

      <ModalFooter>
        <Button color="success" onClick={handleSubmit}>Guardar</Button>
        <Button color="danger" onClick={onClose}>Cancelar</Button>
      </ModalFooter>
    </Modal>
  );
};

export default StepForm;
